/**
 * Section Group Component
 * 
 * Container for multiple sections with consistent spacing.
 * Based on FAQ page section organization.
 */

import type { ReactNode } from 'react';

interface SectionGroupProps {
  children: ReactNode;
  className?: string;
}

export default function SectionGroup({ children, className = '' }: SectionGroupProps) {
  return (
    <div className={`space-y-12 ${className}`}>
      {children}
    </div>
  );
}